/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export const fontFamilyBold =
  "'ApercuBold', 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const fontFamilyNormal =
  "'ApercuRegular', 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const defaultFontSize = '16px';

export const fontSizes = {
  h1: '42px',
  h2: '28px',
  h3: '24px',
  h4: '20px',
  h5: '18px',
  h6: '16px',
  body: '16px',
  body1: '14px',
  caption: '12px',
  title: '36px',
  modalTitle: '32px'
};

const fonts = {
  bold: (fontSize: string) => `normal ${fontSize} ${fontFamilyBold}`,
  normal: (fontSize: string) => `normal ${fontSize} ${fontFamilyNormal}`
};

export default fonts;
